import React, { Component } from "react";

// @ts-ignore
import WorkflowStepRunning from "./WorkflowStepRunning";
// @ts-ignore
import WorkflowStepFailed from "./WorkflowStepFailed";
// @ts-ignore
import WorkflowStepSuccessful from "./WorkflowStepSuccessful";
// @ts-ignore
import WorkflowStepService from "./WorkflowStepService";
// @ts-ignore
import WorkflowStepWaiting from "./WorkflowStepWaiting";
// @ts-ignore
import { log } from "../../../../redux/modules/logger/api";

import { connect } from "react-redux";
import {
  customerHasPermissions,
  siteHasPermissions,
} from "../../../../acl/utils";

import {
  WORKFLOW_STEP_STATUS_FAILED,
  WORKFLOW_STEP_STATUS_RUNNING,
  WORKFLOW_STEP_STATUS_SERVER_PROCESSING,
  WORKFLOW_STEP_STATUS_SUCCESSFUL,
  WORKFLOW_STEP_STATUS_WAITING,
  WORKFLOW_TYPE_BASE_SURFACE,
  WORKFLOW_TYPE_SITE_CREATION,
  WORKFLOW_TYPE_TARGET_SURFACE,
} from "../../../../redux/modules/workflow/constants";

import {
  Workflow,
  WorkflowAction,
  WorkflowStep,
} from "../../../../redux/modules/workflow/reducer";
import { AclState } from "../../../../acl/reducer";
import { rollbackWorkflowStep } from "../../../../redux/modules/workflow/actions";
import { AppDispatch } from "../../../../store";
import { GlobalState } from "../../../../redux/modules/rootReducer";

type WorkflowStepProps = {
  // own props
  siteId: string | null;
  customerId: string;
  step: WorkflowStep;
  requiredActionPermissions: string[];
  requiredRollbackPermissions: string[];
  onSubmit: (actions: WorkflowAction[]) => void;

  // bound props
  acl: AclState;
  workflow: Workflow;
  userEmail: string;
  dispatch: AppDispatch;
};

export class WorkflowStepComponent extends Component<WorkflowStepProps> {
  componentDidMount() {
    const {
      acl,
      workflow: { workflowType, id: workflowId },
      siteId,
      customerId,
      step: { id: stepId },
      requiredRollbackPermissions,
      userEmail,
    } = this.props;
    isRollbackAvailable(
      customerId,
      siteId,
      workflowType,
      acl,
      requiredRollbackPermissions,
      stepId,
      userEmail,
      workflowId,
      true,
    );
  }

  render() {
    const {
      acl,
      workflow,
      siteId,
      customerId,
      step,
      requiredActionPermissions,
      requiredRollbackPermissions,
      onSubmit,
      dispatch,
    } = this.props;

    const { id: workflowId, workflowType } = workflow;
    const { id: stepId } = step;
    const isRollbackAvailableFlag = isRollbackAvailable(
      customerId,
      siteId,
      workflowType,
      acl,
      requiredRollbackPermissions,
      stepId,
    );

    switch (step.status) {
      case WORKFLOW_STEP_STATUS_SUCCESSFUL:
        return (
          <WorkflowStepSuccessful
            step={step}
            isRollbackAvailable={isRollbackAvailableFlag}
            onRollback={() => {
              dispatch(
                rollbackWorkflowStep(customerId, siteId, workflowId, stepId),
              );
            }}
          />
        );
      case WORKFLOW_STEP_STATUS_RUNNING:
        if (
          userCanSeeTheStep(
            customerId,
            siteId,
            acl,
            requiredActionPermissions,
            step.isInputStep,
          )
        ) {
          return <WorkflowStepRunning step={step} onSubmit={onSubmit} />;
        }

        return (
          <WorkflowStepService
            step={step}
            isRunning={true}
            isRollbackAvailable={isRollbackAvailableFlag}
            onRollback={() => {
              dispatch(
                rollbackWorkflowStep(customerId, siteId, workflowId, stepId),
              );
            }}
          />
        );
      case WORKFLOW_STEP_STATUS_FAILED:
        if (
          userCanSeeTheStep(
            customerId,
            siteId,
            acl,
            requiredActionPermissions,
            step.isInputStep,
          )
        ) {
          return (
            <WorkflowStepFailed
              step={step}
              onSubmit={onSubmit}
              isRollbackAvailable={isRollbackAvailableFlag}
              onRollback={() => {
                dispatch(
                  rollbackWorkflowStep(customerId, siteId, workflowId, stepId),
                );
              }}
            />
          );
        }

        return (
          <WorkflowStepService
            step={step}
            isRunning={true}
            isRollbackAvailable={isRollbackAvailableFlag}
            onRollback={() => {
              dispatch(
                rollbackWorkflowStep(customerId, siteId, workflowId, stepId),
              );
            }}
          />
        );
      case WORKFLOW_STEP_STATUS_SERVER_PROCESSING:
        return (
          <WorkflowStepService
            step={step}
            isRunning={true}
            isRollbackAvailable={isRollbackAvailableFlag}
            onRollback={() => {
              dispatch(
                rollbackWorkflowStep(customerId, siteId, workflowId, stepId),
              );
            }}
          />
        );
      case WORKFLOW_STEP_STATUS_WAITING:
        if (
          userCanSeeTheStep(
            customerId,
            siteId,
            acl,
            requiredActionPermissions,
            step.isInputStep,
          )
        ) {
          return <WorkflowStepWaiting step={step} />;
        }

        return (
          <WorkflowStepService
            step={step}
            isRunning={false}
            isRollbackAvailable={isRollbackAvailableFlag}
            onRollback={() => {
              dispatch(
                rollbackWorkflowStep(customerId, siteId, workflowId, stepId),
              );
            }}
          />
        );
      default:
        console.warn("cannot render step", step.status);
        return null;
    }
  }
}

export default connect((state: GlobalState) => ({
  acl: state.acl,
  userEmail: state.user.email,
  workflow: Object.values(state.workflows.entries)[0].entry,
}))(WorkflowStepComponent);

function userCanSeeTheStep(
  customerId: string,
  siteId: string | null,
  acl: AclState,
  requiredActionPermissions: string[],
  isInputStep?: boolean,
) {
  if (isInputStep) {
    // everyone has permission to input data
    return true;
  }

  // this is a service step. Only moderator can handle it
  if (
    (siteId &&
      siteHasPermissions(
        acl,
        requiredActionPermissions,
        `${customerId}/${siteId}`,
      )) ||
    customerHasPermissions(acl, requiredActionPermissions, customerId)
  ) {
    // user is moderator
    return true;
  }

  // user not allowed to perform the step
  return false;
}

function isRollbackAvailable(
  customerId: string,
  siteId: string | null,
  workflowType: string,
  acl: AclState,
  requiredRollbackPermissions: string[],
  stepId: number,
  userEmail?: string,
  workflowId?: string,
  loggingEnabled = false,
) {
  const sitePermissionOk = siteId
    ? siteHasPermissions(
        acl,
        requiredRollbackPermissions,
        `${customerId}/${siteId}`,
      )
    : false;
  const customerPermissionOk = customerHasPermissions(
    acl,
    requiredRollbackPermissions,
    customerId,
  );

  let forbidden = false;
  if (!sitePermissionOk && !customerPermissionOk) {
    // user is not a moderator
    forbidden = true;
  }

  // only 4th, 5th or 6th steps of onboarding workflow
  // and 4th step of scan workflow can be rolled back
  const workflowAllowsRollback =
    (workflowType === WORKFLOW_TYPE_SITE_CREATION &&
      [4, 5, 6].includes(stepId)) ||
    (workflowType === WORKFLOW_TYPE_TARGET_SURFACE && [4].includes(stepId)) ||
    (workflowType === WORKFLOW_TYPE_BASE_SURFACE && [3].includes(stepId));
  forbidden = forbidden || !workflowAllowsRollback;

  if (loggingEnabled === true) {
    const context = {
      sitePermissionOk,
      customerPermissionOk,
      siteId,
      stepId,
      workflowType,
      message: "isRollbackAvailable check",
      forbidden,
      userEmail,
      workflowId,
    };
    const logMessage = JSON.stringify(context);
    log(logMessage);
    // console.log(logMessage)
  }

  return !forbidden;
}
